import { Destination, Kind } from "../../graphql/generated";
import { BPBaseResource } from "./base-resource";

export type MinimumDestination = Pick<Destination, "spec" | "metadata">;

export class BPDestination extends BPBaseResource implements Destination {
  __typename?: Kind.Destination | undefined;

  constructor(d: MinimumDestination) {
    super();

    this.kind = Kind.Destination;
    this.metadata = d.metadata;
    this.spec = d.spec;
  }
}
